<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-link
          v-b-modal="'Log111'"
          style="text-decoration: underline; color: #46E0E5; text-align: right;"
          @click="$refs.childref.tableIncident(11, '')"
        >
          <span style="font-size:14px;">ดูเพิ่มเติ่ม</span>
          <feather-icon
            icon="ChevronRightIcon"
            size="24"
          />
        </b-link>
      </b-col>
    </b-row>
    <div>
      <Log ref="childref" />
    </div>
  </div>
</template>

<script>
import {
  // BCard,
  BRow, BCol, BLink,
} from 'bootstrap-vue'
// import axios from '@axios'
import Log from '@/views/analyticscifi/analyticdetailfi2/ModalLog.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    // BButton,

    Log,
  },
  data() {
    return {

    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    // this.interval = setInterval(() => {
    //   this.getSemEvent()
    // }, 10000)
  },
  methods: {

  },
}
</script>
<style lang="scss">

</style>
